import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Download, FileText } from 'lucide-react';
import Header from '../components/layout/Header';
import VerdictBadge from '../components/analysis/VerdictBadge';
import { api } from '../services/api';

export default function ReportsPage() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;
    api.getReports().then((items) => { if (mounted) setReports(items); }).finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  return (
    <div className="page-container">
      <Header showBack backLabel="Rapports PDF" onBack={() => navigate(-1)} />
      <section className="mx-4 mt-6">
        <h1 className="text-2xl font-extrabold text-brand-navy">Rapports PDF</h1>
        <p className="mt-2 text-sm text-text-muted">Téléchargez les rapports générés pour vos analyses récentes.</p>
      </section>
      {loading ? <p className="mx-4 mt-10 text-center text-text-muted">Chargement des rapports...</p> : null}
      {!loading && !reports.length ? <EmptyReports onAnalyze={() => navigate('/analyze')} /> : null}
      <section className="mx-4 mt-6 space-y-3 md:grid md:grid-cols-2 xl:grid-cols-3 md:gap-3 md:space-y-0">
        {reports.map((report) => (
          <article key={report.id} className="card flex items-center gap-4">
            <span className="w-12 h-12 rounded-xl bg-brand-navy/10 text-brand-navy flex items-center justify-center"><FileText className="w-6 h-6" /></span>
            <div className="flex-1 min-w-0"><p className="font-bold text-text-primary truncate">{report.label}</p><p className="text-xs text-text-muted">{report.ref} · {report.time}</p><div className="mt-2"><VerdictBadge verdict={report.verdict} /></div></div>
            <button type="button" onClick={() => api.downloadReportPdf(report)} className="w-11 h-11 rounded-xl border border-brand-navy text-brand-navy flex items-center justify-center active:scale-95 transition-transform" aria-label={`Télécharger le PDF ${report.ref}`}><Download className="w-5 h-5" /></button>
          </article>
        ))}
      </section>
    </div>
  );
}

function EmptyReports({ onAnalyze }) {
  return (
    <div className="mx-4 mt-10 card text-center py-8">
      <FileText className="w-12 h-12 mx-auto text-text-subtle" />
      <h2 className="mt-4 font-bold text-brand-navy">Aucun rapport disponible</h2>
      <p className="mt-2 text-sm text-text-muted">Analysez un lien, un email ou un QR code pour générer un rapport PDF.</p>
      <button type="button" onClick={onAnalyze} className="btn-primary mt-5">Analyser maintenant</button>
    </div>
  );
}
